import styles from './AnchorBlock.module.css'

export type AnchorBlockProps = {
  content: React.ReactNode
}

export const PhnxAnchorBlock: React.FC<AnchorBlockProps> = ({ content }) => {
  return <div className={styles.anchorblock}>{content}</div>
}
